import { render } from "./InjuryDeadthAlysis.vue?vue&type=template&id=28bc89e0&scoped=true"
import script from "./InjuryDeadthAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryDeadthAlysis.vue?vue&type=script&lang=js"

import "./InjuryDeadthAlysis.vue?vue&type=style&index=0&id=28bc89e0&lang=scss&scoped=true"
import "./InjuryDeadthAlysis.vue?vue&type=style&index=1&id=28bc89e0&lang=scss&scoped=true"
import "./InjuryDeadthAlysis.vue?vue&type=style&index=2&id=28bc89e0&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bc89e0"]])

export default __exports__